import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  LanguageCodeEnum,
  NameTranslationInput
} from "../../types/globalTypes";
import TranslationsProductLensTypePage, {
  fieldNames
} from "../components/TranslationsProductLensTypePage";
import { TypedUpdateProductLensTypeTranslations } from "../mutations";
import { TypedProductLensTypeTranslationDetails } from "../queries";
import { UpdateProductLensTypeTranslations } from "../types/UpdateProductLensTypeTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsProductLensTypeQueryParams {
  activeField: string;
}
export interface TranslationsProductLensTypeProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsProductLensTypeQueryParams;
}

const TranslationsProductLensType: React.FC<TranslationsProductLensTypeProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateProductLensTypeTranslations) => {
    if (data.productLensTypeTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedProductLensTypeTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {productLensTypeTranslations => (
        <TypedUpdateProductLensTypeTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: NameTranslationInput = {};
              if (field === fieldNames.name) {
                input.name = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsProductLensTypePage
                activeField={params.activeField}
                disabled={
                  productLensTypeTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(
                      lang,
                      TranslatableEntities.productLensType,
                      id
                    )
                  )
                }
                onSubmit={handleSubmit}
                lensType={maybe(
                  () => productLensTypeTranslations.data.productLensType
                )}
              />
            );
          }}
        </TypedUpdateProductLensTypeTranslations>
      )}
    </TypedProductLensTypeTranslationDetails>
  );
};
TranslationsProductLensType.displayName = "TranslationsProductLensType";
export default TranslationsProductLensType;
